document.addEventListener( 'DOMContentLoaded', function() {
	const tabWrappers = document.querySelectorAll( '.tabs-wrapper' );

	if ( ! tabWrappers.length ) {
		return;
	}

	tabWrappers.forEach( function( wrapper ) {
		const tabLinks = wrapper.querySelectorAll( '.tab-link' );
		const tabContents = wrapper.querySelectorAll( '.tab-content' );
		const tabPreviewWrappers = wrapper.querySelectorAll( '.tab-preview-wrapper' );
		const isSideTabs = wrapper.classList.contains( 'side-tabs' );

		function getActiveSideTabMediaBlock() {
			if ( ! isSideTabs ) {
				return null;
			}
			return wrapper.querySelector( '.tab-panels .tab-content.is-active .media-block' );
		}

		tabLinks.forEach( function( link, index ) {
			link.addEventListener( 'click', function( event ) {
				event.preventDefault();
				const tabId = this.getAttribute( 'aria-controls' );

				// Update tab links
				tabLinks.forEach( function( innerLink ) {
					innerLink.setAttribute( 'aria-selected', 'false' );
					innerLink.setAttribute( 'tabindex', '-1' );
					innerLink.classList.remove( 'is-active' );
				} );
				this.setAttribute( 'aria-selected', 'true' );
				this.setAttribute( 'tabindex', '0' );
				this.classList.add( 'is-active' );

				// Update tab content
				tabContents.forEach( function( content ) {
					if ( content.id === tabId ) {
						content.classList.add( 'is-active' );
						content.removeAttribute( 'hidden' );
					} else {
						content.classList.remove( 'is-active' );
						content.setAttribute( 'hidden', '' );
					}
				} );

				// Update tab preview wrappers (for Side Tabs)
				tabPreviewWrappers.forEach( function( previewWrapper, previewIndex ) {
					if ( previewIndex === index ) {
						previewWrapper.classList.add( 'is-active' );
						previewWrapper.classList.remove( 'is-hover' );
					} else {
						previewWrapper.classList.remove( 'is-active' );
						previewWrapper.classList.remove( 'is-hover' );
					}
				} );
			} );

			// Add hover functionality for side tabs
			if ( isSideTabs ) {
				link.addEventListener( 'mouseenter', function() {
					const previewWrapper = tabPreviewWrappers[ index ];
					if ( previewWrapper && ! previewWrapper.classList.contains( 'is-active' ) ) {
						previewWrapper.classList.add( 'is-hover' );
					}

					// Change the main image on hover
					const targetTabContent = tabContents[ index ];
					if ( targetTabContent ) {
						const targetImage = targetTabContent.querySelector( '.media-block img' );
						const mainMediaBlock = getActiveSideTabMediaBlock();

						if ( targetImage && mainMediaBlock ) {
							const mainImage = mainMediaBlock.querySelector( 'img' );
							if ( mainImage ) {
								// Store original image data if not already stored
								if ( ! mainImage.dataset.originalSrc ) {
									mainImage.dataset.originalSrc = mainImage.src;
									mainImage.dataset.originalAlt = mainImage.alt;
								}

								// Change to hovered tab's image
								mainImage.src = targetImage.src;
								mainImage.alt = targetImage.alt;
								mainImage.style.opacity = '1';
							}
						}
					}
				} );

				link.addEventListener( 'mouseleave', function() {
					const previewWrapper = tabPreviewWrappers[ index ];
					if ( previewWrapper ) {
						previewWrapper.classList.remove( 'is-hover' );
					}

					// Restore the active tab's image or original image
					const mainMediaBlock = getActiveSideTabMediaBlock();
					if ( mainMediaBlock ) {
						const mainImage = mainMediaBlock.querySelector( 'img' );
						if ( mainImage ) {
							// Find the currently active tab
							const activeTabLink = wrapper.querySelector( '.tab-link[aria-selected="true"]' );
							if ( activeTabLink ) {
								const activeIndex = Array.from( tabLinks ).indexOf( activeTabLink );
								const activeTabContent = tabContents[ activeIndex ];
								if ( activeTabContent ) {
									const activeImage = activeTabContent.querySelector( '.media-block img' );
									if ( activeImage ) {
										mainImage.src = activeImage.src;
										mainImage.alt = activeImage.alt;
									}
								}
							} else if ( mainImage.dataset.originalSrc ) {
								// Fallback to original image if no active tab
								mainImage.src = mainImage.dataset.originalSrc;
								mainImage.alt = mainImage.dataset.originalAlt;
							}
							mainImage.style.opacity = '1';
						}
					}
				} );
			}
		} );

		// Add keyboard navigation
		wrapper.addEventListener( 'keydown', function( event ) {
			const currentTab = document.activeElement;
			let newTab;

			if ( event.key === 'ArrowRight' || event.key === 'ArrowLeft' ) {
				const currentIndex = Array.from( tabLinks ).indexOf( currentTab );

				if ( event.key === 'ArrowRight' ) {
					newTab = tabLinks[ ( currentIndex + 1 ) % tabLinks.length ];
				} else if ( event.key === 'ArrowLeft' ) {
					newTab = tabLinks[ ( currentIndex - 1 + tabLinks.length ) % tabLinks.length ];
				}

				if ( newTab ) {
					newTab.focus();
					newTab.click();
				}
			}
		} );
	} );
} );

